export function isLinkSelected(url: string): boolean {
  const currentUrl = window.location.pathname + window.location.search;
  if (url.includes('?')) {
    return currentUrl === url;
  }
  return currentUrl === url || currentUrl.startsWith(url + '?') || currentUrl.startsWith(url + '/');
}
